module.exports = require("../export-contract.js")(
  require("../patterns/nl.js")
);
